import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.css'],
  standalone: false
})
export class LogoComponent implements OnInit, OnDestroy {
  @Input() providerTitle!: string;
  @Input() providerLogo!: string;

  logo: string | null = null;
  private subscriptions = new Subscription();

  constructor(
    private sharedDataService: SharedDataService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.sharedDataService.userLoaded$
        .pipe(
          filter((loaded) => loaded),
          map(() => this.userService.getLadLogo(this.sharedDataService.getCurrentUser() ?? undefined))
        )
        .subscribe((logo) => {
          this.logo = logo;
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
